export default __webpack_public_path__ + "static/media/reviews.88c4b63b.svg";